<tlk-modal-header header>
	<span class="header-title">
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="header-icon"><path d="M9 17H7A5 5 0 0 1 7 7h2"></path><path d="M15 7h2a5 5 0 1 1 0 10h-2"></path><line x1="8" x2="16" y1="12" y2="12"></line></svg>
		{{ 'PatientLinking.Title' | translate }}
	</span>
	<button tlkButton variant="ghost" size="l" right-icon (click)="close()"><tlk-close-empty-icon class="tlk-icon_size_l"/></button>
</tlk-modal-header>
<tlk-modal-content content [style.flex]="1" [style.overflow-y]="'auto'" [style.display]="'flex'" [style.flex-direction]="'column'">
	<div class="content-wrap">
		<!-- SOURCE PATIENT -->
		<div class="source-section">
			<div class="section-label">{{ sourceDescription | translate }}</div>
			<div class="patient-row patient-row--source">
				<div class="radio-col radio-col--disabled">
					<span class="radio radio--selected"></span>
				</div>
				<rx-patient-avatar
					[firstName]="sourcePatient.firstName"
					[lastName]="sourcePatient.lastName"
					[thumbnailUrl]="(sourcePatient.invisalignId && thumbnailUrls.get(sourcePatient.invisalignId)) || null">
				</rx-patient-avatar>
				<div class="field-name">{{ sourcePatient.lastName }}, {{ sourcePatient.firstName }}</div>
				<div class="field-gender">{{ sourcePatient.gender | genderInitial }}</div>
				<div class="field-dob">{{ sourcePatient.dateOfBirth ? (sourcePatient.dateOfBirth | dobFormat) : '—' }}</div>
				<div class="field-chart">{{ sourcePatient.chartNumber || '—' }}</div>
				<div class="field-badge"><span tlk-badge [backgroundColor]="data.direction === 'iTero' ? '#F2EBFF' : '#DFF5FC'" textColor="dark" size="m">{{ data.direction === 'iTero' ? 'iTero' : 'Invisalign' }}</span></div>
			</div>
			<p class="candidates-label">{{ candidatesDescription | translate }}</p>
		</div>

		<!-- CANDIDATES LIST -->
		<div class="candidates-list" role="radiogroup">
			<button
				*ngFor="let candidate of data.candidates"
				type="button"
				role="radio"
				[attr.aria-checked]="selectedTarget === candidate.patient"
				class="patient-row patient-row--candidate"
				[class.patient-row--active]="selectedTarget === candidate.patient"
				[class.patient-row--disabled]="candidate.wouldCreateDuplicate"
				[disabled]="candidate.wouldCreateDuplicate"
				(click)="selectTarget(candidate)"
			>
				<div class="radio-col">
					<span class="radio" [class.radio--selected]="selectedTarget === candidate.patient"></span>
				</div>
				<rx-patient-avatar
					[firstName]="candidate.patient.firstName"
					[lastName]="candidate.patient.lastName"
					[thumbnailUrl]="(candidate.patient.invisalignId && thumbnailUrls.get(candidate.patient.invisalignId)) || null">
				</rx-patient-avatar>
				<div class="field-name">{{ candidate.patient.lastName }}, {{ candidate.patient.firstName }}</div>
				<div class="field-gender">{{ candidate.patient.gender | genderInitial }}</div>
				<div class="field-dob">{{ candidate.patient.dateOfBirth ? (candidate.patient.dateOfBirth | dobFormat) : '—' }}</div>
				<div class="field-chart">{{ candidate.patient.chartNumber || '—' }}</div>
				<div class="field-badge"><span tlk-badge [backgroundColor]="targetSystem === 'iTero' ? '#F2EBFF' : '#DFF5FC'" textColor="dark" size="m">{{ targetSystem === 'iTero' ? 'iTero' : 'Invisalign' }}</span></div>
			</button>
		</div>

		<!-- DIFFERENT PERSON -->
		<div class="different-person-section" *ngIf="!data.confirmOnly">
			<button
				type="button"
				[attr.aria-pressed]="selectedCreateNew"
				class="different-person"
				[class.different-person--active]="selectedCreateNew"
				[class.different-person--disabled]="!data.canCreateNew"
				[disabled]="!data.canCreateNew"
				(click)="selectCreateNew()"
			>
				<div class="radio-col">
					<span class="radio" [class.radio--selected]="selectedCreateNew"></span>
				</div>
				<div class="different-person-text">
					<span class="different-person-title">{{ 'PatientLinking.DifferentPerson' | translate }}</span>
					<span class="different-person-subtitle">{{ 'PatientLinking.DifferentPersonSubtitle' | translate }}</span>
				</div>
			</button>
		</div>
	</div>
</tlk-modal-content>
<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button tlkButton variant="secondary" size="m" (click)="close()">
			<span class="btn-icon-wrap">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="btn-arrow-icon"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg>
			</span>
			{{ 'PatientLinking.Back' | translate }}
		</button>
		<button tlkButton variant="primary" size="m" [disabled]="!canLink" (click)="confirmLink()">
			{{ confirmLabel | translate }}
		</button>
	</ng-container>
</tlk-modal-footer>
